import React from 'react';
import { selectLoginResponse } from '../redux/login/login.selector';
import { useSelector } from 'react-redux';
import { API_URL } from '../redux/config';

const Search = () => {
	const loginResponse = useSelector(selectLoginResponse);

	// Debug: Log the login response structure
	if (process.env.NODE_ENV === 'development') console.log('Search component - loginResponse:', loginResponse);

	// Check if loginResponse exists and has the required properties
	// Try different possible structures
	const organisationName =
		loginResponse?.data?.organisationName || loginResponse?.organisationName || 'VIDUPPU';

	const organisationLogo =
		loginResponse?.data?.organisationLogo || loginResponse?.organisationLogo;

	return (
		<>
			<div className='d-flex align-items-center w-100' data-tour='search'>
				{organisationLogo && (
					<img
						src={`${API_URL}${organisationLogo}`}
						alt={`${organisationName} Logo`}
						style={{
							height: '50px',
							width: 'auto',
							objectFit: 'contain',
							marginLeft: '1rem',
						}}
						onError={(e) => {
							if (process.env.NODE_ENV === 'development') console.log('Logo image failed to load:', e.currentTarget.src);
							e.currentTarget.style.display = 'none';
						}}
					/>
				)}
				<div className='d-flex flex-column ms-4'>
					<span className='fw-bold fs-4 text-primary text-uppercase'>
						{organisationName}
					</span>
					<span className='fw-semibold fs-5 text-uppercase'>DASHBOARD FOR VIDUPPU</span>
				</div>
			</div>
		</>
	);
};

export default Search;
